import Button from "components/Button/Button"
import { CalendarCustom } from "components/Calendar/Calendar"
import CheckedDefault from "components/Checked/CheckedDefault"
import { ClearAll } from "components/Filter"
import { FilterCollapse } from "components/Filter/FilterCollapse"
import { FilterHeader } from "components/Filter/FilterHeader"
import InputDefault from "components/Input/InputDefault"
import { TippyCustomzie, useTippyLayout } from "components/TippyCustomzie"
import { useWindowSize } from "helpers/hooks"
import { formatDate, formatOrganizationByUsers } from "helpers/utils"
import { useAppSelector } from "hooks/useApp"
import { includes } from "lodash"
import ActionIconHistory from "pages/project-component-detail/molecules/ActionIconHistory"

import { useContext } from "react"

import "react-date-range/dist/styles.css" // main style file
import "react-date-range/dist/theme/default.css" // theme css file
import { ConversationsPageContext } from "../contexts/ConversationsPage.context"
import {
  MENU_TAB_CONVERSATION,
  SelectionRangeDetail,
  MENU_TAB_KEY,
  CONVERSATION_GROUP_BY_OPTIONS,
  CONVERSATION_TAB_OPTIONS,
} from "../conversations.type"
import FormSelectFilter from "../molecules/FormSelectFilter"
import SelectMulti from "components/Select/SelectMulti"
interface Props {
  isSearch: boolean
  inputSearch: string
  isFilter: boolean
  isShowFavorite: boolean
  selectionRange: SelectionRangeDetail
  isCalendarRanges: boolean
  endDateCreate: Date | null
  startDateCreate: Date | null
  isCalendarLastUpdate: boolean
  selectionDate: Date | null
  dateLastUpdate: Date | null
  isActiveIconFilter: boolean
  onChangeCheckboxFavorite: () => void
  onChangeInputSearch: (event) => void
  onKeyPress: (event: React.KeyboardEvent<HTMLDivElement>) => void
  onOpenInputSearch: () => void
  setIsFilter: (newIsFilter: boolean) => void
  onChangeDate: (ranges: any) => void
  onApplySelectionRanges: () => void
  onCancelSelectionRanges: (
    startDateCreate: Date | null,
    endDateCreate: Date | null
  ) => void
  onChangeModalSelectRanges: (
    newValue: boolean,
    startDate: Date | null,
    endDate: Date | null
  ) => () => void
  onClearInputSelectionRanges: () => void
  onChangeModalDateLastUpdate: (
    newValue: boolean,
    dateLastUpdate?: Date | null
  ) => () => void
  onChangeDateLastUpdate: (newDate: any) => void
  onApplySelectionDateLastUpdate: () => void
  onClearInputSelectionDateLastUpdate: () => void
  onCancelSelectionlastUpdate: (oldDate: Date | null) => void
  handleChangeFilerAll: (newAll: boolean) => () => void
  onApplyFilter: () => void
  onOpenModalFiler: (newOpen: boolean) => void
  onRemoveInputSearch: () => void
  rollbackFilter: () => void
  onChangeCheckboxDelete: () => void
  isShowDeleted: boolean
  isShowUnread: boolean
  onChangeCheckBoxUnread: () => void
  isShowArchive: boolean
  onChangeCheckBoxArchive: () => void
  unreadByFilter: number
  isShowDraft: boolean
  onChangeCheckBoxDraft: () => void
  groupOption: string
  onChangeGroupOption: (option: string) => void
  organizationActive: {
    value: string
    setValue: (value: string) => void
  }
  filterTab: {
    value: string
    setValue: (value: string) => void
  }
  filterOrganization: {
    value: string
    setValue: (value: string) => void
  }
  // type: "Conversation" | "Build overview" = "Conversation"
}
const ConversationFilter = (props: Props) => {
  const {
    isSearch,
    inputSearch,
    isFilter,
    isShowFavorite,
    selectionRange,
    endDateCreate,
    startDateCreate,
    onChangeInputSearch,
    onKeyPress,
    onOpenInputSearch,
    onChangeCheckboxFavorite,
    onChangeDate,
    isCalendarRanges,
    onApplySelectionRanges,
    onCancelSelectionRanges,
    onChangeModalSelectRanges,
    onClearInputSelectionRanges,
    isCalendarLastUpdate,
    selectionDate,
    dateLastUpdate,
    onChangeModalDateLastUpdate,
    onChangeDateLastUpdate,
    onApplySelectionDateLastUpdate,
    onCancelSelectionlastUpdate,
    onClearInputSelectionDateLastUpdate,
    handleChangeFilerAll,
    onApplyFilter,
    onOpenModalFiler,
    isActiveIconFilter,
    onRemoveInputSearch,
    rollbackFilter,
    onChangeCheckboxDelete,
    isShowDeleted,
    isShowUnread,
    isShowArchive,
    isShowDraft,
    onChangeCheckBoxArchive,
    onChangeCheckBoxUnread,
    onChangeCheckBoxDraft,
    groupOption,
    onChangeGroupOption,
    filterTab,
    filterOrganization,
  } = props
  const type = "Conversations"
  const {
    cpnStatusOptions,
    cpnTypeOptions,
    objSelectType,
    objSelectStatus,
    setObjSelectStatus,
    setObjSelectType,
    customStatuses,
    setObjSelectCustomStatus,
    objSelectCustomStatus,
  } = useContext(ConversationsPageContext)
  const userInfo = useAppSelector((state) => state.userInfo)
  const { isMobile } = useWindowSize()
  const { TippyLayout } = useTippyLayout()
  const organizations = formatOrganizationByUsers(userInfo.organizations)

  const checkAllFilter = () => {
    if (dateLastUpdate || startDateCreate || endDateCreate) {
      return false
    }
    if (
      !isShowFavorite &&
      !isShowDeleted &&
      !isShowUnread &&
      !isShowArchive &&
      !isShowDraft &&
      !Object.values(objSelectType).filter((el) => el).length &&
      !Object.values(objSelectStatus).filter((el) => el).length &&
      !filterOrganization.value &&
      !(filterTab.value && filterTab.value !== "all") &&
      groupOption === "latest_message"
    ) {
      if (
        includes(
          [
            MENU_TAB_KEY[MENU_TAB_CONVERSATION.TO_ME],
            MENU_TAB_KEY[MENU_TAB_CONVERSATION.CC],
          ],
          filterTab.value
        )
      ) {
        return !Object.values(objSelectCustomStatus).filter((el) => el).length
      }
      return true
    }
    return false
  }

  const renderConversationFilter = () => (
    <div>
      <ActionIconHistory
        onClick={() => onOpenModalFiler(!isFilter)}
        icon="filter"
        tooltip="Filter"
        styleIcon={{
          marginRight: 0,
        }}
        classActiveIcon={isActiveIconFilter ? "action-icon-filter" : ""}
      />
    </div>
  )

  const renderCreateDate = () => (
    <CalendarCustom
      label="Creation period"
      type="date-range"
      visible={isCalendarRanges}
      currentDate={[selectionRange]}
      selectedDate={
        startDateCreate && endDateCreate ? (
          <p className="font-normal text-14 leading-24 text-orange-5">
            {`${formatDate(startDateCreate, "DD MMM yyyy")} - ${formatDate(
              endDateCreate,
              "DD MMM yyyy"
            )}`}
          </p>
        ) : null
      }
      onSelectDate={onChangeDate}
      showClear={!!(startDateCreate && endDateCreate)}
      onClear={onClearInputSelectionRanges}
      onCancel={() => {
        onCancelSelectionRanges(startDateCreate, endDateCreate)
      }}
      onApply={onApplySelectionRanges}
      onOpen={onChangeModalSelectRanges(
        !isCalendarRanges,
        startDateCreate,
        endDateCreate
      )}
    />
  )

  const renderUpdateDate = () => (
    <CalendarCustom
      label="Last message date"
      placehoder="Search up to this date"
      visible={isCalendarLastUpdate}
      currentDate={selectionDate}
      selectedDate={
        dateLastUpdate ? (
          <p className="font-normal text-14 leading-24 text-orange-5">
            {`${formatDate(dateLastUpdate, "DD MMM yyyy")}`}
          </p>
        ) : null
      }
      onSelectDate={onChangeDateLastUpdate}
      showClear={!!dateLastUpdate}
      onClear={onClearInputSelectionDateLastUpdate}
      onCancel={() => onCancelSelectionlastUpdate(dateLastUpdate)}
      onApply={onApplySelectionDateLastUpdate}
      onOpen={onChangeModalDateLastUpdate(!isCalendarLastUpdate)}
    />
  )

  /// render conversion filter content on mobile
  const renderConversionFilterDynamic = () => (
    <div>
      <ClearAll
        onClick={handleChangeFilerAll(checkAllFilter())}
        active={!checkAllFilter()}
      />

      <CheckedDefault
        className="justify-between flex-row-reverse h-[52px] bg-white border-t-[1px] border-b-[1px] px-6"
        textColor="black"
        tilteClass="ml-0"
        checked={isShowFavorite}
        onClick={onChangeCheckboxFavorite}
        title="Show favorite only"
      />
      <CheckedDefault
        className="justify-between flex-row-reverse h-[52px] bg-white border-t-[1px] border-b-[1px] px-6"
        textColor="black"
        tilteClass="ml-0"
        checked={isShowUnread}
        onClick={onChangeCheckBoxUnread}
        title="Show unread only"
      />
      <CheckedDefault
        className="justify-between flex-row-reverse h-[52px] bg-white border-t-[1px] border-b-[1px] px-6"
        textColor="black"
        tilteClass="ml-0"
        checked={isShowArchive}
        onClick={onChangeCheckBoxArchive}
        title="Show archive"
      />
      <CheckedDefault
        className="justify-between flex-row-reverse h-[52px] bg-white border-t-[1px] border-b-[1px] px-6"
        textColor="black"
        tilteClass="ml-0"
        checked={isShowDraft}
        onClick={onChangeCheckBoxDraft}
        title="Show draft only"
      />
      <CheckedDefault
        className="justify-between flex-row-reverse h-[52px] bg-white border-t-[1px] border-b-[1px] px-6"
        textColor="black"
        tilteClass="ml-0"
        checked={isShowDeleted}
        onClick={onChangeCheckboxDelete}
        title="Show deleted only"
      />

      <div className="flex flex-col">
        <FilterCollapse
          label="View type"
          data={CONVERSATION_TAB_OPTIONS.map((el) => ({
            value: el.value,
            label: el.key,
          }))}
          chosenValue={filterTab.value}
          onChange={(data) => {
            if (
              includes(
                [
                  MENU_TAB_KEY[MENU_TAB_CONVERSATION.FROM_ME],
                  MENU_TAB_KEY[MENU_TAB_CONVERSATION.OTHERS],
                  MENU_TAB_KEY[MENU_TAB_CONVERSATION.CC],
                ],
                data.value
              )
            ) {
              if (setObjSelectCustomStatus && groupOption === "custom_status") {
                setObjSelectCustomStatus({})
                onChangeGroupOption("latest_message")
              }
            }
            filterTab.setValue(filterTab.value === data.value ? "" : data.value)
          }}
        />
        <FilterCollapse
          label="Component type"
          multiActive
          data={cpnTypeOptions.map((el) => ({
            value: el.value,
            label: el.key,
          }))}
          chosenValue={objSelectType}
          onChange={setObjSelectType}
        />

        <FilterCollapse
          label="Build status"
          multiActive
          data={cpnStatusOptions
            .filter((el) => !includes(["Draft", "Committed"], el.key))
            .map((el) => ({
              value: el.value,
              label: el.key,
            }))}
          chosenValue={objSelectStatus}
          onChange={setObjSelectStatus}
        />
        <FilterCollapse
          label="Sort by"
          data={(includes(
            [MENU_TAB_KEY[MENU_TAB_CONVERSATION.TO_ME]],
            filterTab.value
          ) && customStatuses.length
            ? CONVERSATION_GROUP_BY_OPTIONS
            : CONVERSATION_GROUP_BY_OPTIONS.filter(
                (el) => el.value !== "custom_status"
              )
          ).map((el) => ({
            value: el.value,
            label: el.key,
          }))}
          chosenValue={groupOption}
          onChange={(data) => {
            if (data.value === groupOption) {
              onChangeGroupOption("latest_message")
              if (setObjSelectCustomStatus) {
                setObjSelectCustomStatus({})
              }
              return
            }
            if (data.value !== "custom_status" && setObjSelectCustomStatus) {
              setObjSelectCustomStatus({})
            }
            onChangeGroupOption(data.value)
          }}
        />
        {includes(
          [MENU_TAB_KEY[MENU_TAB_CONVERSATION.TO_ME]],
          filterTab.value
        ) &&
          customStatuses.length &&
          groupOption === "custom_status" && (
            <FilterCollapse
              label="Conversation status"
              multiActive
              data={customStatuses.map((el) => ({
                value: el.id,
                label: el.name,
              }))}
              chosenValue={objSelectCustomStatus}
              onChange={setObjSelectCustomStatus}
            />
          )}
        <div className="flex flex-col mt-[12px] px-[24px]">
          <p className="text-[14px] font-semibold text-[#111111] mb-[4px]">
            Workspace
          </p>
          <SelectMulti
            options={[
              {
                label: "All",
                value: "",
              },
              ...organizations.map((el) => ({
                label: el.name,
                value: el.db_name,
              })),
            ]}
            selectedOption={
              filterOrganization.value
                ? {
                    label:
                      organizations.find(
                        (el) => el.db_name === filterOrganization.value
                      )?.name || "All",
                    value: filterOrganization.value,
                  }
                : {
                    label: "All",
                    value: "",
                  }
            }
            handleChange={(changedData) => {
              filterOrganization.setValue(changedData.value || "")
            }}
            isMulti={false}
            noOptionsMessage
            customMenuStyle={{
              border: `1px solid #e5e7eb`,
              background: "#FFFFFF",
            }}
            customSingleValueStyle={{
              color: "#000000",
            }}
          />
        </div>
        <div className="flex flex-col px-6 mb-6">
          {renderCreateDate()}
          {renderUpdateDate()}
        </div>
      </div>
    </div>
  )

  /// conversion filter content on desktop
  const renderConversionFilterContent = () => (
    <div
      className="pt-3.5 pb-3"
      style={{
        background: "#222222",
        borderRadius: 4,
      }}
    >
      <div className="flex items-center justify-between mb-3 px-3">
        <p className="hidden md:block font-semibold text-16 leading-26 text-white">
          Filter
        </p>
        <ClearAll
          onClick={handleChangeFilerAll(checkAllFilter())}
          active={!checkAllFilter()}
        />
      </div>
      <div className="flex flex-col px-[12px] mb-[12px]">
        <div className="grid grid-cols-3 gap-[12px]">
          <CheckedDefault
            checked={isShowFavorite}
            onClick={onChangeCheckboxFavorite}
            title="Show favorite only"
            tilteClass="whitespace-nowrap"
          />
          <CheckedDefault
            checked={isShowUnread}
            onClick={onChangeCheckBoxUnread}
            title="Show unread only"
            tilteClass="whitespace-nowrap"
          />
          <CheckedDefault
            checked={isShowDraft}
            onClick={onChangeCheckBoxDraft}
            title="Show draft only"
            tilteClass="whitespace-nowrap"
          />
        </div>
        <div className="grid grid-cols-3 gap-[12px] mt-[12px]">
          <CheckedDefault
            checked={isShowDeleted}
            onClick={onChangeCheckboxDelete}
            title="Show deleted only"
            tilteClass="whitespace-nowrap"
          />
          <CheckedDefault
            checked={isShowArchive}
            onClick={onChangeCheckBoxArchive}
            title="Show archive"
            tilteClass="whitespace-nowrap"
          />
        </div>
      </div>
      <div className="flex flex-col my-[8px] px-3">
        <p className="text-[13px] font-semibold text-[#7A7A7A] mb-[4px]">
          Workspace
        </p>
        <SelectMulti
          options={[
            {
              label: "All",
              value: "",
            },
            ...organizations.map((el) => ({
              label: el.name,
              value: el.db_name,
            })),
          ]}
          selectedOption={
            filterOrganization.value
              ? {
                  label:
                    organizations.find(
                      (el) => el.db_name === filterOrganization.value
                    )?.name || "All",
                  value: filterOrganization.value,
                }
              : {
                  label: "All",
                  value: "",
                }
          }
          handleChange={(changedData) => {
            filterOrganization.setValue(changedData.value || "")
          }}
          isMulti={false}
          noOptionsMessage
          customMenuStyle={{
            border: `1px solid transparent`,
            background: "#333333",
          }}
          customSingleValueStyle={{
            color: "#FFFFFF",
          }}
        />
      </div>
      <div className="flex">
        <FormSelectFilter
          title="View type"
          dataSelects={CONVERSATION_TAB_OPTIONS}
          type="single"
          objActiveSelect={filterTab.value}
          setObjActiveSelect={(data) => {
            if (
              includes(
                [
                  MENU_TAB_KEY[MENU_TAB_CONVERSATION.FROM_ME],
                  MENU_TAB_KEY[MENU_TAB_CONVERSATION.OTHERS],
                  MENU_TAB_KEY[MENU_TAB_CONVERSATION.CC],
                ],
                data
              )
            ) {
              if (setObjSelectCustomStatus && groupOption === "custom_status") {
                setObjSelectCustomStatus({})
                onChangeGroupOption("latest_message")
              }
            }
            filterTab.setValue(filterTab.value === data ? "" : data)
          }}
        />
        <FormSelectFilter
          title="Component type"
          dataSelects={cpnTypeOptions}
          objActiveSelect={objSelectType}
          setObjActiveSelect={(data) => {
            if (isShowDeleted) {
              return
            }
            if (setObjSelectType) {
              setObjSelectType(data)
            }
          }}
        />
        <FormSelectFilter
          title="Build status"
          dataSelects={cpnStatusOptions}
          styleRoot={{
            borderRight: "none",
          }}
          objActiveSelect={objSelectStatus}
          setObjActiveSelect={(data) => {
            if (isShowDeleted) {
              return
            }
            if (setObjSelectStatus) {
              setObjSelectStatus(data)
            }
          }}
        />

        <FormSelectFilter
          title="Sort by"
          dataSelects={
            includes(
              [MENU_TAB_KEY[MENU_TAB_CONVERSATION.TO_ME]],
              filterTab.value
            ) && customStatuses.length
              ? CONVERSATION_GROUP_BY_OPTIONS
              : CONVERSATION_GROUP_BY_OPTIONS.filter(
                  (el) => el.value !== "custom_status"
                )
          }
          type="single"
          objActiveSelect={groupOption}
          setObjActiveSelect={(data) => {
            if (data === groupOption) {
              onChangeGroupOption("latest_message")
              if (setObjSelectCustomStatus) {
                setObjSelectCustomStatus({})
              }
              return
            }
            if (data !== "custom_status" && setObjSelectCustomStatus) {
              setObjSelectCustomStatus({})
            }
            onChangeGroupOption(data)
          }}
        />
        {includes(
          [MENU_TAB_KEY[MENU_TAB_CONVERSATION.TO_ME]],
          filterTab.value
        ) &&
        customStatuses.length &&
        groupOption === "custom_status" ? (
          <FormSelectFilter
            title="Conversation status"
            dataSelects={customStatuses.map((el) => ({
              key: el.name,
              value: el.id,
            }))}
            styleRoot={{
              borderRight: "none",
            }}
            objActiveSelect={objSelectCustomStatus}
            setObjActiveSelect={(data) => {
              if (isShowDeleted) {
                return
              }
              if (setObjSelectCustomStatus) {
                setObjSelectCustomStatus(data)
              }
            }}
          />
        ) : null}
      </div>

      <div className="grid grid-cols-2 gap-[12px] mt-2 px-3">
        {renderCreateDate()}
        {renderUpdateDate()}
      </div>

      <div className="flex justify-end mt-3 mr-3">
        <Button
          title="Apply"
          onClick={onApplyFilter}
          widthBtn={120}
          heightBtn={42}
        />
      </div>
    </div>
  )

  /// render conversion filter content
  const renderConversionFilterLayout = () =>
    isMobile ? (
      <TippyLayout
        visible={isFilter}
        headerContent={
          <FilterHeader setVisible={onOpenModalFiler} onApply={onApplyFilter} />
        }
        mainContent={renderConversionFilterDynamic()}
      >
        {renderConversationFilter()}
      </TippyLayout>
    ) : (
      <TippyCustomzie
        containerClass="component-card-menu"
        placement="bottom-end"
        interactive
        arrow={false}
        animation="scale"
        visible={isFilter}
        onClickOutside={() => {
          rollbackFilter()
          onOpenModalFiler(!isFilter)
        }}
        offset={[-265, 5]}
        content={renderConversionFilterContent()}
        allowHTML
      >
        {renderConversationFilter()}
      </TippyCustomzie>
    )

  return (
    <div className="flex flex-col gap-2 justify-between mb-2 pr-6">
      <div className="flex justify-between items-center w-full">
        <div className="font-semibold text-black text-base"> {type}</div>
        <div className="flex gap-3">
          {isSearch ? (
            <div className="custom-icon-remove-search mx-2">
              <ActionIconHistory
                onClick={onRemoveInputSearch}
                disabled
                icon="close-modal"
                tooltip="Remove search"
                styleIcon={{
                  marginRight: 0,
                }}
              />
            </div>
          ) : (
            <ActionIconHistory
              onClick={onOpenInputSearch}
              icon="search"
              tooltip="Search"
              styleIcon={{
                marginRight: 8,
              }}
            />
          )}

          {renderConversionFilterLayout()}
        </div>
      </div>
      {isSearch ? (
        <InputDefault
          onChange={onChangeInputSearch}
          autoFocus
          placeholder="Enter search"
          onKeyPress={onKeyPress}
          value={inputSearch}
          style={{
            height: 30,
            flexGrow: 1,
            maxWidth: isMobile ? undefined : "222px",
          }}
        />
      ) : null}
    </div>
  )
}
export default ConversationFilter
